<template>
  <div ref="operaionButtonWidthDiv">
    <div v-if="!isSingle">
      <div v-if="order.status !=12 && order.status != 30 && order.status != 20 && order.fee_adjustment_list.length > 0 && !trackTask">
        <PaymentDialog v-if="order.fee_adjustment_list[0].status=='0'" v-on:success="updatePayment" :mobiletype="mobiletype" :order="order" :paymentId="order.payment_type_id" :fromOrder="true" :singleID="order.conditions.single_id" style="display:block;margin-bottom: 10px;">
          <el-button class="block btn-14" type="info">确认支付</el-button>
        </PaymentDialog>
      </div>
      <div v-if="groupOrderLine && groupOrderLine.length && groupOrderLine[0].status == 0 && !trackTask">
        <div v-if="order.status == 11 && !isSingle && !hasAttention">
          <img src="../../../assets/images/homepage/weapp.jpg" height="100%" width="100%"/>
          <!-- <AddressDialog v-if="!isSingle"  :address-id="order.address_id" v-on:success="updateAddress" v-on:complete="complete" style="display:block;margin-top: 10px;">
            <el-button class="block btn-14" type="info">更改地址</el-button>
          </AddressDialog>
          <OrderCancelDialog v-if="!isSingle" :order="order" style="display:block;margin-top: 10px;" :mobiletype="mobiletype" v-on:complete="complete">
            <el-button class="block btn-14">取消任务</el-button>
          </OrderCancelDialog> -->
        </div>
      </div>
        <div v-if="order.status == 12">
          <PaymentDialog v-on:success="updatePayment" :order="order" :fromOrder="true" :mobiletype="mobiletype" :paymentId="order.payment_type_id" :singleID="order.conditions.single_id" style="display:block;">
            <el-button class="block btn-14" type="info">确认支付</el-button>
          </PaymentDialog>
        </div>
        <!-- <div v-if="order.status == 13">
          <OrderCancelDialog :order="order" style="display:block;" :mobiletype="mobiletype" v-on:complete="complete">
            <el-button class="block btn-14">取消任务</el-button>
          </OrderCancelDialog>
        </div> -->
      <!-- <div v-if="['1', '4','5','6'].indexOf(groupOrderLine[0].status) > -1 && !trackTask">
        <OrderVoucher :groupOrderLine="groupOrderLine" :isSingle="isSingle" :mobiletype="mobiletype" :order="order" style="display:block;">
          <el-button class="block btn-14" type="info">下单凭证</el-button>
        </OrderVoucher>
      </div>
      <div v-if="groupOrderLine[0].status == 2 && !trackTask" class="text">
        <OrderVoucher :groupOrderLine="groupOrderLine" :isSingle="isSingle" :mobiletype="mobiletype" :order="order" style="display:block;">
          <el-button class="block btn-14">下单凭证</el-button>
        </OrderVoucher>
      </div> -->
      <div v-if="groupOrderLine && groupOrderLine.length && (groupOrderLine[0].status == 4 || groupOrderLine[0].status == 5 || groupOrderLine[0].status == 6)">
        <div v-if="order.fee_adjustment_list.length > 0 && !trackTask">
          <OrderConfirm :groupOrderLine="groupOrderLine" v-if="order.fee_adjustment_list[0].status!='0'" :packageId="packageId" :order="order" style="display:block;" v-on:complete="complete">
            <el-button class="block btn-14" type="info">确认完成</el-button>
          </OrderConfirm>
        </div>
        <div v-if="order.fee_adjustment_list.length == 0 && !trackTask">
          <OrderConfirm :groupOrderLine="groupOrderLine" :packageId="packageId" :order="order" style="display:block;" v-on:complete="complete">
            <el-button class="block btn-14" type="info">确认完成</el-button>
          </OrderConfirm>
        </div>
        <OrderTrackDialog :normal_address_show="normal_address_show" :groupOrderLine="groupOrderLine" @updateGroupLine="updateGroupLine" :mobiletype="mobiletype" :packageId="packageId" :order="order" :trackTask="trackTask" style="display:block;margin-top: 10px;">
          <el-button class="block btn-14" type="info">包裹跟踪</el-button>
        </OrderTrackDialog>
      </div>
    </div>
    <div v-else>
      <el-button class="block btn-14" :loading="task_loading" type="info" @click="begin()" v-if="groupOrderLine && order.status != 11 && groupOrderLine[0].order_status == 13 && groupOrderLine[0].status==0 && order.noNeedPaid && (maishouenable || order.buyer_delegate_account_id==account_id)">开始下单</el-button>
      <el-button class="block btn-14" :loading="task_loading" type="info" @click="take_by_single()" v-if="order.status == 11 && maishouenable">确认接单</el-button>
      <el-button class="block btn-14" type="info" @click="showUploadOrder()" v-if="groupOrderLine && groupOrderLine[0].order_status == 14 && groupOrderLine[0].status==0 && order.noNeedPaid && (maishouenable || order.buyer_delegate_account_id==account_id)">上传下单信息</el-button>
      <el-button class="block btn-14" type="info" @click="showExpress()" v-if="groupOrderLine && groupOrderLine[0].status==1 && (role==2 || maishouenable || order.business_shipping_account_id==account_id || order.buyer_delegate_account_id==account_id)">上传商家物流</el-button>
      <!-- 图文模式初始没有包裹概念，所以暂时图文模式的下单委托不加入包裹状态的判断条件 -->
      <!--<el-button class="block btn-14 nohover" style="margin-bottom: 10px;" @click="showOrderDelegate()" v-if="[13,14,15].indexOf(+order.status)>-1 && ((order.type!=2 && (+groupOrderLine[0].status)<4) || order.type==2)  && order.noNeedPaid && maishouenable">
        {{ order.buyer_delegate_account_id && order.buyer_delegate_account_id!='0' && order.transport_shipping_account_id == order.buyer_delegate_account_id?`${order.buyer_delegate_username}下单&转运`:(order.buyer_delegate_username?order.buyer_delegate_username+'下单':'下单委托') }}
      </el-button>-->
    </div>
    <singleOrderOpertion :totalAccountList="totalAccountList" :zhuanyun_role_enable="zhuanyun_role_enable" :normal_address_show="normal_address_show" :shippingArr="shippingArr" v-on:lineChange="lineChange" 
      v-on:complete="complete" v-if="isSingle" 
      :mobiletype="mobiletype" :order="order" :packageId="packageId" 
      :isSingle="isSingle" :groupOrderLine="groupOrderLine" @updateGroupLine="updateGroupLine">
    </singleOrderOpertion>
    <div v-if="groupOrderLine && groupOrderLine.length && groupOrderLine[0].status == 2" class="text">
      <OrderTrackDialog :normal_address_show="normal_address_show" :groupOrderLine="groupOrderLine" :packageId="packageId" :mobiletype="mobiletype" :order="order" :trackTask="trackTask" :isSingle="isSingle" style="display:block;" @updateGroupLine="updateGroupLine">
        <el-button class="block btn-14 nohover">包裹跟踪</el-button>
      </OrderTrackDialog>
    </div>

    <div v-if="isSingle && order.status != 11 && ((groupOrderLine && groupOrderLine[0].status!=3) && order.status != 30 ) && ((groupOrderLine && groupOrderLine[0].order_status!=13) || (order.status != 20 && order.status != 12 &&order.status!=30&& (maishouenable || order.business_shipping_account_id==account_id) &&order.type==0&&order.status!=16))">
      <el-dropdown :disabled="groupOrderLine.loading" style="width:100%;margin:10px 0;" @command="handleCommand" v-if="groupOrderLine && groupOrderLine[0].status<6">
        <el-button class="block btn-14 nohover">
          操 作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu class="operationStatus" :style="{width:buttonWidth}" slot="dropdown">
          <el-dropdown-item v-if="order.business.country == 'JP' && single_type!=2 && groupOrderLine && groupOrderLine[0].order_status == 14 && groupOrderLine[0].status==0 && (maishouenable || order.buyer_delegate_account_id==account_id)" command="3">提交代购单</el-dropdown-item>
          <el-dropdown-item v-if="groupOrderLine && groupOrderLine[0].order_status!=13" command="1">撤 回</el-dropdown-item>
          <el-dropdown-item v-if="groupOrderLine && [0,1].indexOf(+groupOrderLine[0].status)>-1 && (maishouenable || order.business_shipping_account_id==account_id)" command="2">取消商品</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog v-if="otherPaymentDialogVisible" class="el-dialog-sm" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="otherPaymentDialogVisible" width="90%">
      <PaymentTip v-on:close="closeOtherPaymentDialogVisible" :orderId="order.id" :newWindow="newWindow" :order="order" :type="order.payment_type_id"></PaymentTip>
    </el-dialog>
  </div>
</template>

<script>
import AddressDialog from '../../publish_task/address/AddressDialog'
import OrderCancelDialog from './OrderCancelDialog'
import PaymentDialog from '../../publish_task/payment/PaymentDialog'
import OrderConfirm from './OrderConfirm'
import OrderTrackDialog from './OrderTrackDialog'
import OrderVoucher from './OrderVoucher'
import api from '../../../services/api.js'
import singleOrderOpertion from './single/OrderOperation'
import {API_HOST} from '../../../services/constant.js'
import PaymentTip from '../../payment/PaymentTip'

export default {
  name: 'OrderList',
  props: ['order', 'packageId', 'totalAccountList','groupOrderLine', 'isSingle', 'mobiletype', 'trackTask','shippingArr'
  ,'normal_address_show','zhuanyun_role_enable','task_loading'],
  components: {
    AddressDialog: AddressDialog,
    OrderCancelDialog: OrderCancelDialog,
    PaymentDialog: PaymentDialog,
    OrderConfirm: OrderConfirm,
    OrderTrackDialog: OrderTrackDialog,
    singleOrderOpertion: singleOrderOpertion,
    PaymentTip: PaymentTip,
    OrderVoucher: OrderVoucher
  },
  data () {
    return {
      buttonWidth:'',
      wechatDialogVisible: false,
      otherPaymentDialogVisible: false,
      newWindow: null,
      completion: false,
      status: null,
      operationType: '1', // 操作类别
      type: '', // 商品or任务
      refund: '', // 退款
      role:this.$localStorage.get('role'),
      account_id:this.$localStorage.get('account_id')
    }
  },
  computed:{
    single_type () {
	    return this.$store.state.single_type
    },
    maishouenable(){
      //包含系统买手管理员role=1，商家买手管理员，普通任务买手
      return this.role==1 || this.order.single_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1) 
    },
    hasAttention(val){
      return !!(this.$store.state.userInfo && this.$store.state.userInfo.wechat.open_id)
    }
  },
  mounted() {
    this.buttonWidth = this.$refs.operaionButtonWidthDiv.clientWidth+'px'
  },
  methods: {
    handleCommand(e){
      this.$store.commit('setPackageId',this.groupOrderLine[0].package_id)
      let params={order_id:this.order.id}
      switch(e){
        case "3":
            this.showDaigouOrder();
          break;
        case "1":
          this.$store.commit('setPackageId',this.groupOrderLine[0].package_id)
          if(this.groupOrderLine[0].status==5){
            params.type=4
            params.package_id_list=[this.groupOrderLine[0].package_id]
            break;
          }
          if(this.groupOrderLine[0].status==4){
            params.type=2
            params.package_id_list=[this.groupOrderLine[0].package_id]
            break;
          }
          if(this.groupOrderLine[0].status==1){
            params.type=3
            params.good_id_list=this.groupOrderLine.map(i=>i.id)
            break;
          }
          if(this.groupOrderLine[0].order_status==14){
            params.type=1
            break;
          }
      }
      if(e!=3)
        this.$emit('callBack',{type:e,params:params})
    },
    begin(){
      this.$emit('begin')
    },
    take_by_single(){
      this.$emit('takebysingle')
    },
    showDaigouOrder(){
      this.$emit('showDaigouOrder')
    },
    showUploadOrder(){
      this.$store.commit('setPackageId',this.groupOrderLine[0].package_id)
      this.$emit('showUploadOrder')
    },
    showExpress(){
      this.$store.commit('setPackageId',this.groupOrderLine[0].package_id)
      this.$emit('showExpress')
    },
    showOrderDelegate(){
      this.$emit('showOrderDelegate')
    },
    updateGroupLine(data){
      console.log('here')
      this.$emit('updateGroupLine',data)
    },
    lineChange () {
      this.$emit('lineChange')
    },
    async updateAddress (data) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'update_address_by_buyer',
        data: {
          order_id: this.order.id,
          address_id: data.address_id,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        let data = res.result
        data.coupon = JSON.parse(data.coupon)
        Object.assign(this.order, data)
        this.$forceUpdate()
      }
    },
    closeOtherPaymentDialogVisible: function () {
      this.otherPaymentDialogVisible = false
    },
    
    async updatePayment (data) {
      if (data.type == 3) {
        this.newWindow = window
      }
      let offline_payment = 0
      if(data.type == 0){
        offline_payment = 1 
      }
      let payment_type_id = await this.savePayment(data)
      console.log(payment_type_id)
      let res = await api.post(this, {
        path: 'order.php',
        api: 'update_payment_type_by_buyer',
        data: {
          order_id: this.order.id,
          payment_type_id: payment_type_id,
          offline_payment: offline_payment,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        if(res.result.offline_payment == '1' || res.result.payment_type_id == '70') {
          this.order.status = '13'
          return
        }
        this.order.update_time = res.result.update_time
        this.order.payment_type_id = data.type
        this.otherPaymentDialogVisible = true
      }
    },
    async savePayment (data) {
      let apiPayment = 'add_payment_type'
      let res = await api.post(this, {
        path: 'buyer.php',
        api: apiPayment,
        data: data,
        loading: 'loading'
      })
      return res.body.result
    },
    complete (data){
      this.$emit('complete', data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text {
  text-align: center;
  color:rgba(136,136,136,1);
  line-height:18px;
}
.redirct {
    font-size:24px;
    font-family:PingFangSC-Regular;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderOperation.vue